/** @file POSE_LAYOUT: the per-node columns of a PoseBuffer (design section 5 step 1, rulings R2). */

/**
 * Column offsets of one node in a `PoseBuffer` (`Float64Array` of `nodeCount * stride`, node order =
 * `Object.keys(puppet.nodes)`). `px py pz`: position **entity-relative**, after facing, tilt and mirror, unsnapped, in
 * units (no `zScaleView`). `qx qy qz qw`: world rotation (facing included), camera-free. `scale`: the node's scale.
 * `flags`: bits per `POSE_FLAGS` (hidden, rotToggle, yawFlipped, frame key). `yaw`, `pitch`: degrees read back from
 * world rotation x the node's own or inherited rest (18.2), camera-free; what the facet lookup classifies.
 * `parentIndex`: the effective parent this frame (flex parents, 17.5), -1 for a root. `ox oy oz` (CR-003, 21.4): the
 * node's **bone origin**, entity-relative like `px py pz`: the effective parent's position plus the rotated
 * `originOffset` and this frame's key translation (a root: `originOffset + translation`); placement reads it for
 * screen rotation and second points instead of rebuilding it from positions.
 */
export const POSE_LAYOUT = {
  stride: 15, px: 0, py: 1, pz: 2, qx: 3, qy: 4, qz: 5, qw: 6, scale: 7, flags: 8, yaw: 9, pitch: 10, parentIndex: 11,
  ox: 12, oy: 13, oz: 14,
} as const;
